// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { COTIZADOR_ACT_SET_EDITING_QUOTE } from './constants'

export function actSetEditingQuote(editing, quoteEditing) {
  return {
    type: COTIZADOR_ACT_SET_EDITING_QUOTE,
    args: { editing, quoteEditing },
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COTIZADOR_ACT_SET_EDITING_QUOTE:
      return {
        ...state,
        editing: action.args.editing,
        quoteEditing: action.args.quoteEditing,
      }

    default:
      return state
  }
}
